import React from "react";
import DOMPurify from "dompurify";
import ScrollAnimation from "react-animate-on-scroll";
import "animate.css";

import Awarding_1 from "../../img/awards/1.webp";
import Awarding_2 from "../../img/awards/2.webp";
import Awarding_3 from "../../img/awards/3.webp";

function Awarding({ awardingData }) {
    // console.log(awardingData);

    return (
        <>
            {awardingData && (
                <>
                    <section className="relative py-20 lg:h-96 xl:h-[810px] flex flex-col justify-center mb-[40px] lg:mb-[80px]
                        before:absolute before:inset-0 before:bg-gray-900/50 before:content-['']">
                        <img
                            src={awardingData.awarding_photo}
                            className="absolute inset-0 w-full h-full object-cover -z-10"
                            alt=""
                        />

                        <div className="container relative z-10 max-w-screen-xl mx-auto px-[15px]">
                            <div className="text-white text-center">
                                <h2 className="text-2xl font-semibold mb-5 lg:text-4xl xl:text-5xl">
                                    {awardingData.awarding_title}
                                </h2>

                                <div
                                    className="text-xl"
                                    dangerouslySetInnerHTML={{
                                        __html: DOMPurify.sanitize(
                                            awardingData.awarding_text,
                                            {
                                                sanitize: true,
                                            }
                                        ),
                                    }}
                                />
                            </div>
                        </div>
                    </section>

                    <section className="mb-[60px] lg:mb-[120px]">
                        <div className="container max-w-screen-xl mx-auto px-[15px] ">
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-2 lg:gap-4 mb-10">
                                <img src={Awarding_1}  alt="img" className="w-full h-72 object-cover" />
                                <img src={Awarding_2}  alt="img" className="w-full h-72 object-cover" />
                                <img src={Awarding_3}  alt="img" className="w-full h-72 object-cover" />
                            </div>

                            <div className="text-center">
                                <a href="#" className="inline-block text-center bg-[#ece66a] text-black font-bold px-5 py-3 uppercase tracking-widest
                                    hover:bg-[#F5D858] transition-all duration-300 ease-out">
                                    Дізнатись переможців
                                </a>
                            </div>
                        </div>
                    </section>
                </>
            )}
        </>
    );
}

export default Awarding;